import { EReduxTypes } from 'ts/enums/redux.types';
import type { IModalState } from 'ts/interfaces/modal/modal';
import type { IReduxAction } from 'ts/interfaces/redux/redux.action';

const initialState: IModalState = {
  type: '',
  visible: false,
  options: {}
};

const modalsReducer = (state = initialState, action: IReduxAction) => {
  switch (action.type) {
    case EReduxTypes.TOGGLE_MODAL: {
      const { type, visible, options } = action.data;
      return {
        ...state,
        visible,
        type,
        options: visible && options ? options : {}
      };
    }
    default:
      return state;
  }
};

export default modalsReducer;
